import "../styles/Header.css"; // si tienes estilos propios
import Navbar from "./Navbar";

function Header() {
  return (
    <header className="header">
      <a href="/home" className="logo">
        <img src="/logoPw.png" alt="Logo Agencia Pretty Woman" />
        <h2>Team Andy</h2>
      </a>
      <nav className="Nav">
      <Navbar/>
      </nav>
    </header>
  );
}

export default Header;
